<template>
  <div class="custom-select-wrapper" :class="{ 'settings-screen': useInsideSettingsScreen }">
    <div class="custom-select  " @click.stop="toggleDropdown">
      <div class="custom-select__trigger pb-3 d-flex align-center">
        <v-icon v-if="selectedCountry.region_code === 'WW'" class="mr-4 mt-2">mdi-google-earth</v-icon>
        <country-flag v-else :country="selectedCountry &&
          selectedCountry.region_code &&
          (selectedCountry.region_code !== 'WW'
            ? selectedCountry.region_code
            : 'us'
          ).toLowerCase()
          " class="mr-1" />

        <span class="mt-2">
          {{ selectedCountry.region_name || "Select Country" }}
        </span>

        <i class="caret"></i>
      </div>
      <div class="custom-options" :class="{ open: dropdownOpen }">
        <span v-for="(country, index) in countries" :key="index" class="custom-option d-flex align-center"
          @click.stop="selectCountry(country)">
          <v-icon v-if="getCountryCode(country) === 'ww'" class="ml-1 mr-4">mdi-google-earth</v-icon>
          <country-flag :country="getCountryCode(country)" v-else class="mr-1" />
          <span>{{ country.region_name }}</span>
        </span>
      </div>
    </div>
  </div>
</template>



<script>

import CountryFlag from "vue-country-flag-next";

export default {
  name: "CountrySelect",
  components: {
    CountryFlag,
  },
  props: {
    countries: {
      type: Array,
      required: true,
    },
    selectedCountryProp: {
      // Add the prop to accept the initial selected country.
      type: Object,
      default: () => ({}),
    },
    useInsideSettingsScreen: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dropdownOpen: false,
      selectedCountry: this.selectedCountryProp,
    };
  },
  methods: {
    toggleDropdown() {
      this.dropdownOpen = !this.dropdownOpen;
    },
    selectCountry(country) {
      this.selectedCountry = country;
      this.dropdownOpen = false;
      this.$emit("country-selected", country);
    },
    closeDropdown() {
      this.dropdownOpen = false;
    },
    getCountryCode(country) {
      if (country && country.region_code) {
        return (
          country.region_code !== "WW" ? country.region_code : "WW"
        ).toLowerCase();
      }
      return "";
    },
  },
  watch: {
    // Watch for changes on the selectedCountryProp prop.
    selectedCountryProp(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.selectedCountry = newVal; // Update the local data property when the prop changes.
      }
    },
  },
  mounted() {
    document.addEventListener("click", this.closeDropdown);
  },
  beforeUnmount() {
    document.removeEventListener("click", this.closeDropdown);
  },
};

</script>



<style lang="scss" scoped>

.custom-select-wrapper {
  width: 300px;
  position: relative;
  user-select: none;
  box-shadow: vars.get-map-value(vars.$input, 'country-select', 'box-shadow');
  border-radius: 8px;

  &.settings-screen {
    .custom-select {
      color: vars.get-map-value(vars.$input, 'country-select', 'settings-screen', 'color');
    }
  }
}

.custom-select {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 16px;
  color: vars.get-map-value(vars.$input, 'country-select', 'color');
  cursor: pointer;
  border-radius: 8px;
  background-color: vars.get-map-value(vars.$input, 'country-select', 'background-color');
}

.custom-select__trigger {
  position: relative;
  flex-grow: 1;
}

.caret {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  border-top: 5px solid;
  border-right: 5px solid transparent;
  border-left: 5px solid transparent;
}

.custom-options {
  position: absolute;
  display: block;
  border-radius: 5px;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 2;
  overflow: auto;
  max-height: 200px;
  opacity: 0;
  visibility: hidden;
  transform: translateY(-10px);
  transition: all 0.3s ease;
  line-height: 10px;
  background-color: vars.get-map-value(vars.$input, 'country-select', 'background-color');
}

.custom-option {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 8px 16px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.custom-option:hover {
  background-color: vars.get-map-value(vars.$input, 'country-select', 'option', 'hover', 'background-color');
}

.open {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}

</style>
